import { Box, CircularProgress, Typography } from "@mui/material";
import { colors } from "../../theme/palette";

export const CircularProgressWithLabel = ({
  value,
  totalNum,
}: {
  value: number | null | undefined;
  totalNum: number;
}) => {
  const validValue = value ?? 0;
  const percentage = (validValue / totalNum) * 100;

  return (
    <Box
      sx={{
        position: "relative",
        width: "56px",
        height: "56px",
      }}
    >
      <CircularProgress
        variant="determinate"
        value={percentage}
        thickness={4}
        size={56}
        sx={{
          color: colors.Green100,
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 10,
          background: "transparent",
        }}
      />
      <CircularProgress
        variant="determinate"
        value={100}
        thickness={4}
        size={56}
        sx={{
          color: colors.Gray400,
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "56px",
          width: "56px",
        }}
      >
        <Typography
          variant="body12Bold"
          sx={{
            color: colors.Gray400,
          }}
        >
          <Typography
            variant="body12Bold"
            sx={{
              color: colors.Dark1000,
            }}
          >
            {validValue}
          </Typography>
          {`/${totalNum}`}
        </Typography>
      </Box>
    </Box>
  );
};
